import styled from 'styled-components';

import {Button} from '@custom-antd';

export const AddButton = styled(Button)`
  height: 46px;
`;

export const FiltersSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;
